import { Templates } from "../ui/Templates";
import { playerSettingsDg } from "../ui/templates/playerSettingsTemplates";
import { LocalStorageHelper } from "../utilities/LocalStorageHelper";
import { RAPlayer } from "./RAPlayer";

export class RAPlayerSettingsWindow {
	private _ui:HTMLDivElement;
	private _player:RAPlayer;
	
	private _noteNamesCb:HTMLInputElement;
	private _closeBtn:HTMLButtonElement;
	
	private _sessionResolver:(msg:string) => void;
	
	constructor(player:RAPlayer){
		this._player = player;
		this._init();
	}
	
	/**Displays the settings dialog. The Promise will be completed when the user
	 * dismisses the dialog. An optional message string matching a constant from
	 * this class may be included. If not, the string parameter will be null.*/
	public display():Promise<string> {
		return new Promise<string>((resolve, reject) => {
			this._sessionResolver = resolve;
			
			document.body.append(this._ui);
			this._addListeners();
		});
	}
	
	private _init():void {
		this._draw();
	}
	
	private _draw():void {
		this._ui = Templates.createDiv(playerSettingsDg);
		
		this._noteNamesCb = this._ui.querySelector(".psw-fingeringsCb");
		this._closeBtn = this._ui.querySelector(".psw-closeBtn");
		
		this._noteNamesCb.checked = this._player.showNoteNames;
	}
	
	private _onNoteNamesCbChange = (e:Event):void => {
		this._player.changeShowNotesAndFingerings(this._noteNamesCb.checked);
		this._player.renderMusic();
		LocalStorageHelper.setShowFingerings(this._noteNamesCb.checked);
	}
	
	private _onCloseBtnClick = (e:MouseEvent):void => {
		this._close(null);
	}
	
	private _close(message:string):void {
		this._removeListeners();
		this._ui.remove();
		this._sessionResolver(message);
	}
	
	private _addListeners():void {
		this._removeListeners();
		this._noteNamesCb.addEventListener("change", this._onNoteNamesCbChange);
		this._closeBtn.addEventListener("click", this._onCloseBtnClick);
	}
	
	private _removeListeners():void {
		this._noteNamesCb.removeEventListener("change",
			this._onNoteNamesCbChange);
		this._closeBtn.removeEventListener("click", this._onCloseBtnClick);
	}
}